import { Controller } from "@hotwired/stimulus"

// Work Ticket modal helper. Re-inserts the AI-suggested draft reply into the
// shared composer island when the agent clicks "Reset to draft" (the composer
// opens pre-filled; this restores the draft after the agent clears it). The draft text lives in
// the `draft` target; the composer's hidden body input is the `bodyInput`
// target — writing its value and dispatching `email-composer:sync` is the
// island's external-update contract (see EmailComposerIsland). Replacing
// (not appending) matches the button's intent: adopt the AI draft as the
// starting point for the reply.
//
// Collapsing the GOAT Assistant panel is the generic `collapsible` controller's
// job (see the section wrapper in _work_ticket.html.haml), not this one's.
export default class extends Controller {
  static targets = ["draft", "bodyInput"]

  useDraft() {
    if (!this.hasDraftTarget || !this.hasBodyInputTarget) return

    const text = this.draftTarget.textContent.trim()
    if (!text) return

    this.bodyInputTarget.value = draftToHtml(text)
    // Literal must match COMPOSER_SYNC_EVENT (app/frontend/react/components/
    // forms/composerSyncEvent.ts) — this bundle can't import across to the
    // React tree, so the Jest spec imports the constant to pin the coupling.
    this.bodyInputTarget.dispatchEvent(new Event("email-composer:sync"))

    // The composer sits below the assistant panel, so bring it into view —
    // otherwise the click looks like it did nothing on a long ticket.
    const editor = this.element.querySelector('[contenteditable="true"]')
    editor?.focus()
    editor?.scrollIntoView?.({ block: "center" })
  }
}

const HTML_ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }

const escapeHtml = (text) => text.replace(/[&<>"']/g, (char) => HTML_ESCAPES[char])

// The AI draft is plain text: blank lines separate paragraphs, single
// newlines are soft breaks — mirror that structure in the composer's HTML.
function draftToHtml(text) {
  return text
    .split(/\n{2,}/)
    .map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, "<br>")}</p>`)
    .join("")
}
